import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useMediaQuery } from '@mui/material'
import { mobileMaxWidthMediaQuery } from '../../methods/utils'
import { ReactComponent as CartIcon } from '../../images/pages/tariffsV2/cart.svg'
import Cart from '../../pages/Tariffs/Cart'
import Popup from '../Popup'
import 'pages/Styles/UIKit_v2.sass'
import 'pages/Styles/Cart.sass'
import 'pages/Styles/FloatingCartButton.sass'

type Props = {
    cart: any[]
    onRemoveItem: (itemId: string, itemType: string) => void
    onRemovePackageUpgrade?: (upgradeId: string) => void
    onUpdateQuantity: (itemId: string, itemType: string, quantity: number) => void
    onClearCart: () => void
    onBillCreated?: () => void
    onPaymentProofUploaded?: () => void
    onPaymentRequest?: (method: 'card' | 'invoice' | 'sbp') => Promise<boolean> | boolean
    onLoadTariffs?: () => void
    promoCodes?: any
    showSbpButton?: boolean
    $store: any
    $commitToStore: (data: any) => void
}

let FloatingCartButton: any = function FloatingCartButton({ 
    cart, 
    onRemoveItem,
    onRemovePackageUpgrade,
    onUpdateQuantity, 
    onClearCart, 
    onBillCreated, 
    onPaymentProofUploaded,
    onPaymentRequest,
    onLoadTariffs, 
    promoCodes,
    showSbpButton = false,
    $store, 
    $commitToStore 
}: Props) {
    const [showCartPopup, setShowCartPopup] = useState(false)
    const mobile = useMediaQuery(mobileMaxWidthMediaQuery)

    // Подсчитываем количество элементов в корзине
    function getCartItemsCount(): number {
        let count = 0
        
        cart.forEach(item => {
            if (item.type === 'package_v2') {
                // Тариф считается как 1 элемент
                count += 1
                
                // Каждый апгрейд дает +1
                if (item.tariff_upgrades && Array.isArray(item.tariff_upgrades)) {
                    count += item.tariff_upgrades.length
                }
            } else {
                // Каждый дополнительный сервис дает +1
                count += 1
            }
        })
        
        return count
    }

    function handleCartClick() {
        setShowCartPopup(true)
    }

    function handleCloseCart() {
        setShowCartPopup(false)
    }

    // Закрываем popup при сбросе корзины
    React.useEffect(() => {
        if (cart.length === 0 && showCartPopup) {
            setShowCartPopup(false)
        }
    }, [cart.length, showCartPopup])

    // Не показываем кнопку если корзина пуста или не мобильная версия
    if (!mobile || cart.length === 0) {
        return null
    }

    const itemsCount = getCartItemsCount()

    return (
        <>
            {/* Плавающая кнопка корзины */}
            <button 
                className="new floating-cart-button"
                onClick={handleCartClick}
            >
                <div className="floating-cart-content">
                    <CartIcon className="floating-cart-icon" />
                    <span className="floating-cart-text">Корзина</span>
                    {itemsCount > 0 && (
                        <div className="floating-cart-badge">
                            {itemsCount}
                        </div>
                    )}
                </div>
            </button>

            {/* Popup с корзиной */}
            {showCartPopup && (
                <Popup onClose={handleCloseCart} padding="20px">
                    <Cart
                        cart={cart}
                        onRemoveItem={onRemoveItem}
                        onRemovePackageUpgrade={onRemovePackageUpgrade}
                        onUpdateQuantity={onUpdateQuantity}
                        onClearCart={onClearCart}
                        onBillCreated={onBillCreated}
                        onPaymentProofUploaded={onPaymentProofUploaded}
                        onPaymentRequest={onPaymentRequest}
                        onLoadTariffs={onLoadTariffs}
                        promoCodes={promoCodes}
                        showSbpButton={showSbpButton}
                        $store={$store}
                        $commitToStore={$commitToStore}
                    />
                </Popup>
            )}
        </>
    )
}

FloatingCartButton = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(FloatingCartButton)

export default FloatingCartButton
